(function($) {
  //
  // Add Fancybox function
  //
  $('.wp-block-gallery.fancybox-gallery').each(function(i) {
    var idx = i;
    var $items = $(this).find('.blocks-gallery-item')
    $items.each(function() {
      var $link = $(this).find('a');
      var caption = $(this).find('.blocks-gallery-item__caption').text();
      $link.attr({
        'data-fancybox': `gallery-${idx}`,
        'data-caption': caption
      })
    })
  });
})(jQuery);